import yellow1 from '../assets/yellow1.png'
import pink1 from '../assets/pink1.png'
import black1 from '../assets/black1.png'
import gold1 from '../assets/gold1.png'
import blue1 from '../assets/blue1.png'
import green1 from '../assets/green1.png'
import red1 from '../assets/red1.png'
import white1 from '../assets/white1.png'

export const chocoboImages = {
  yellow: yellow1,
  pink: pink1,
  black: black1,
  gold: gold1,
  blue: blue1,
  red: red1,
  white: white1,
  green: green1
}